import { never } from '../util/never'

import type * as Flows from '../../../shared/domain/flows/types.no-deps'
import {
    hasRange,
    hasChoiceRange,
    hasPhotoRange,
    hasTextRange,
    hasDateTimeFields,
} from '../../../shared/domain/flows/typeGuards.no-deps'
import i18next from 'i18next'

export function getValidationMessage(element: Flows.Element | Flows.NestedElement, reason: Flows.FailureReason) {
    switch (reason) {
        case 'min':
            if (!hasRange(element)) return null
            return i18next.t('appcore:ValidationMessage.min', { min: element.min })
        case 'max':
            if (!hasRange(element)) return null
            return i18next.t('appcore:ValidationMessage.max', { max: element.max })
        case 'minChoices':
            if (!hasChoiceRange(element)) return null
            return i18next.t('appcore:ValidationMessage.minChoices', { minChoices: element.minChoices })
        case 'maxChoices':
            if (!hasChoiceRange(element)) return null
            return i18next.t('appcore:ValidationMessage.maxChoices', { maxChoices: element.maxChoices })
        case 'minPhotos':
            if (!hasPhotoRange(element)) return null
            return i18next.t('appcore:ValidationMessage.minPhotos', { minPhotos: element.minPhotos })
        case 'maxPhotos':
            if (!hasPhotoRange(element)) return null
            return i18next.t('appcore:ValidationMessage.maxPhotos', { maxPhotos: element.maxPhotos })
        case 'required':
            if (element.type === 'section') {
                return i18next.t('appcore:ValidationMessage.requiredSection')
            }

            return i18next.t('appcore:ValidationMessage.requiredAnswer')
        case 'invalidSection':
            return i18next.t('appcore:ValidationMessage.invalidSection')
        case 'minChars':
            if (!hasTextRange(element)) return null
            return i18next.t('appcore:ValidationMessage.minChars', { minChars: element.minChars })
        case 'maxChars':
            if (!hasTextRange(element)) return null
            return i18next.t('appcore:ValidationMessage.maxChars', { maxChars: element.maxChars })
        case 'futureLimitInDays':
            if (!hasDateTimeFields(element)) return null
            return i18next.t('appcore:ValidationMessage.futureLimitInDays', {
                futureLimitInDays: element.futureLimitInDays,
            })
        case 'pastLimitInDays':
            if (!hasDateTimeFields(element)) return null
            return i18next.t('appcore:ValidationMessage.pastLimitInDays', { pastLimitInDays: element.pastLimitInDays })
        case 'minUnits':
            if (element.type !== 'unit-select') return null
            return i18next.t('appcore:ValidationMessage.minUnits', { minUnits: element.minUnits })
        case 'maxUnits':
            if (element.type !== 'unit-select') return null
            return i18next.t('appcore:ValidationMessage.maxUnits', { minUnits: element.maxUnits })
        case 'minReports':
            if (element.type !== 'flow') return null
            return i18next.t('appcore:ValidationMessage.minReports', { minReports: element.minReports })
        case 'maxReports':
            if (element.type !== 'flow') return null
            return i18next.t('appcore:ValidationMessage.maxReports', { maxReports: element.maxReports })
        case 'incompleteSubtask':
            if (element.type !== 'flow') return null
            return i18next.t('appcore:ValidationMessage.incompleteTask')
        case 'uploadLimit':
            if (element.type !== 'files-select') return null
            return i18next.t('appcore:ValidationMessage.uploadLimit', { uploadLimit: element.uploadLimit })
        default:
            never(reason)
    }
}
